<style scoped>

</style>
<template>
  <div class="attachments">
    <Attachment
      v-for="file in files"
      :key="file.id"
      :file="file"
      :show-detail="showDetail"
    />
  </div>
</template>
<script>
  import Attachment from './attachment';
  export default {
    components: { Attachment },
    props: {
      files: {
        type: Array,
        default() {
          return [];
        }
      },
      showDetail: {
        type: Boolean,
        default: true
      }
    }
  }
</script>
